'use client'
import React, { useState } from 'react'

import { InputProps } from '@/components/Form/Form.type'

import { inputStyles } from './Form.style'

interface DateInputProps extends InputProps {
  value?: string // Ex: "12/12/1990"
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void // Retorna evento no formato esperado
}

const DateInput: React.FC<DateInputProps> = ({
  label,
  placeholder = 'DD/MM/AAAA',
  value = '',
  onChange,
  required,
  id,
  name,
  size = 'md'
}) => {
  const [inputValue, setInputValue] = useState(value)

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let rawValue = e.target.value.replace(/\D/g, '') // Remove caracteres não numéricos

    // Limita ao formato DD/MM/AAAA
    if (rawValue.length > 2) {
      let day = rawValue.slice(0, 2)
      if (parseInt(day, 10) > 31) day = '31' // Limita a 31
      rawValue = day + '/' + rawValue.slice(2)
    }

    if (rawValue.length > 5) {
      let month = rawValue.slice(3, 5)
      if (parseInt(month, 10) > 12) month = '12' // Limita a 12
      rawValue = rawValue.slice(0, 3) + month + '/' + rawValue.slice(5)
    }

    if (rawValue.length > 10) {
      rawValue = rawValue.slice(0, 10) // Limita ao máximo de 10 caracteres
    }

    // Atualiza o estado local
    setInputValue(rawValue)

    // Cria um evento personalizado para se alinhar ao padrão dos outros inputs
    const customEvent = {
      ...e,
      target: {
        ...e.target,
        value: rawValue, // Atualiza o valor formatado
        name: name || '' // Garante que o nome seja incluído
      }
    } as React.ChangeEvent<HTMLInputElement>

    onChange(customEvent)
  }

  return (
    <div className="mx-auto flex w-full flex-col">
      {label && (
        <label htmlFor={id || name} className="text-md mb-2 font-bold text-teal-800">
          {label}
        </label>
      )}
      <input
        type="text"
        id={id || name}
        name={name}
        value={inputValue}
        required={required}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={inputStyles({ size })}
      />
    </div>
  )
}

export default DateInput
